import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export const Gracias = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousFormData = location.state?.formData || null;

  const handleBack = () => {
    navigate("/contactanos", { state: { formData: previousFormData } });
  };

  return (
    <div className="container-gracias">
      <div className="container-img">
        <FaCheckCircle color="#27D309" size={60} />
      </div>

      <div className="container-img">
        <img
          src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=gracias-mesa-de-trabajo.png&version_id=null"
          alt="persona gracias"
          className="img-personas"
        />
      </div>

      <div className="font24 font700 font-family-montserrat">¡GRACIAS!</div>
      <div className="font-family-montserrat font20 extrabold-800" style={{ color: 'var(--primary-color)' }}>
        ACABAMOS RECIBIR TU RESPUESTA
      </div>
      <div className="ancho100">
        <div className="btn-atras" onClick={handleBack}>
          <div href="#" className="container-atras">
            <img
              src="/img_publics/arrow.png"
              alt="flecha boton"
            />
            <div className="font-family-montserrat color-blanco extrabold-800">
              ATRÁS
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};